import './grid.css';
import focusSetting from './../Focus/settings';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RequestManager from './../../requests/RequestManager';
import ListTask from './../../requests/tasks/content/ListTask';
import Card from './../CardNew';
import Parser from '../../utils/Parser';
import getBadges from './../../utils/Badges';
import Device from '../../devices/device';
import RibbonsUtil from "../../utils/RibbonsUtil"

import store from '../../store';
import LocalStorage from '../DeviceStorage/LocalStorage';
import Translator from '../../requests/apa/Translator';
import { MODAL_EPG, showModal } from '../../actions/modal';
import Utils from "../../utils/Utils";
import {
  CLASS_NAME_DEFAULT_FOCUSABLE_LIST_INFINITE,
  ID_NAME_FIRST_FOCUS_GRID_SECOND_LEVEL
} from "../Focus/constants";
import {removeDynamicFocus} from "../Focus/utils";
import { MUNDIAL_2026 } from '../../containers/Mundial2026/constants';
import logger from 'src/utils/logger/logger';

class Grid extends Component {
  constructor(props) {
    super(props);

    this.typeEnum = Object.freeze({
      Channel: 0,
      Infinite: 1
    });
    this.ch = 0;
    this.totalChannels = 0;

    this.firstCardId = null;
    this.rootClass = 'channels-container';
    this.gridType = props.gridType;
    this.uri = props.request.uri;

    this.DOWN = 'DOWN';
    this.UP = 'UP';

    this.currentUpPage = 1;
    this.currentDownPage = -1;

    // Variables para la refactorización
    this.lastUp = 0;
    this.lastDown = null; // Con este se empieza a contar cual es el ultimo elemento de la paginacion
    this.totalCategory = null; // total de peliculas que contiene la categoria
    this.markupArray = [];
    this.counter = 0;
    this.flagFirstLoad = false;
    this.indexElemenetActive = null;

    this.downClicks = 3;
    this.rows = props.rows;
    this.itemsByRow = props.cols;
    this.itemsByPage = this.rows * this.itemsByRow;
    this.channels = {
      up: [],
      middle: [],
      down: []
    };

    this.focusOutSelector = `#root ${focusSetting.selector}`;
    this.keys = Device.getDevice().getKeys();

    this.state = {
      channels: this.channels.middle
    };

    this.order = { order_id: '50', order_way: 'ASC' };
    this.allItems = [];

    this.firstLoad = this.firstLoad.bind(this);
    this.createGrid = this.createGrid.bind(this);
    this.willUnfocusMiddleHandler = this.willUnfocusMiddleHandler.bind(this);
    this.onFocusUpHandler = this.onFocusUpHandler.bind(this);
    this.onFocusMiddleHandler = this.onFocusMiddleHandler.bind(this);
    this.onFocusDownHandler = this.onFocusDownHandler.bind(this);
    this.focusHandler = this.focusHandler.bind(this);

    this.quantity = props.cols * 2;
    this.lastKey = null;
    this.isKeysBloqued = false;
    this.delayKeyTime = 50;
    this.handleDelayKeyOkTimer = null;
    this.handleDelayKeyOkSafeTime = 1000;
    this.channelsWrapper = null;
    this.divScrolleable = null;
    if(this.isInfiniteList()){
      this.quantity = props.cols * this.rows;
    }
    this.isMagicControlActive = Utils.getMagicControlKey();
    this.haveMenu = props.haveMenu;
  }

  setHandleDelayKeyOkTimer = () => {
    this.handleDelayKeyOkTimer = setTimeout(() => {
      clearTimeout(this.handleDelayKeyOkTimer);
      this.handleDelayKeyOkTimer = null;
    }, this.handleDelayKeyOkSafeTime);
  };

  showModalOTT = () => {
    this.setHandleDelayKeyOkTimer();
    store.dispatch(
      showModal({
        modalType: MODAL_EPG,
        modalProps: {
          menuItems: [
            {
              title: Translator.get('programacion', 'Programación'),
              visible: 1,
              action: () => {
                if (!this.handleDelayKeyOkTimer)
                  this.props.modalOttChannelsAction();
              }
            },
            {
              title: Translator.get('categorias', 'Categorias'),
              visible: 1,
              action: () => {
                this.props.showModalOTTCategoryAction();
              }
            },
            {
              title: Translator.get('buscar', 'Buscar'),
              visible: 1,
              action: () => {
                this.props.modalOttOpenSearchAction();
              }
            },
            {
              title: Translator.get('go_to_menu', 'Ir al menú'),
              visible: 1,
              action: () => {
                this.props.showModalOTTGoToMenuAction();
              }
            }
          ]
        }
      })
    );
  };

  handleDelayKeyOk(e, key, cb) {
    logger.debug('[EpgLogic] handleDelayKey', this.isKeysBloqued, e.keyCode, key);
    if (this.lastKey !== key && this.pressTimer) {
      clearTimeout(this.pressTimer);
    }

    this.isKeysBloqued = !!(this.lastKey === key && this.pressTimer);
    this.lastKey = key;
    if (this.isKeysBloqued) {
      e.stopPropagation();
      e.preventDefault();
      if ('function' === typeof cb) cb();
    } else {
      this.pressTimer = setTimeout(this.resetTimer, this.delayKeyTime);
    }
  }

  handleKeyPress = e => {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    logger.debug('Listening Grid, currentKey:', currentKey);
    switch (currentKey) {
      case 'OK':
        if (
          !this.handleDelayKeyOkTimer &&
          LocalStorage.getItem('config_remote_control') === 'simple'
        ) {
          this.handleDelayKeyOk(e, currentKey, this.showModalOTT);
        }
        break;
      case 'BLUE':
        break;
      case 'GREEN':
        break;
      case 'YELLOW':
        e.preventDefault();
        e.stopPropagation();
        if (!this.state.visible) this.action(e);
        break;
      default:
        break;
    }
  };

  componentDidMount() {
    this.channelsWrapper.addEventListener('keydown', this.handleKeyPress);
    this.firstLoad();
    if (this.divScrolleable) {
      this.divScrolleable.addEventListener('wheel', this.handleScroll, true);
      this.divScrolleable.addEventListener('pointerMove', this.handleScroll, true);
    }
  }

  componentWillUnmount() {
    this.channelsWrapper.removeEventListener('keydown', this.handleKeyPress);
    if (this.divScrolleable) {
      this.divScrolleable.removeEventListener('wheel', this.handleScroll, true);
      this.divScrolleable.removeEventListener('pointerMove', this.handleScroll, true);
    }
  }

  componentWillReceiveProps(newProps) {

    this.firstCardId = null;

    if (typeof newProps.orderFilter === 'string') {
      const orderId = newProps.orderFilter.split('-')[0]
      const orderWay = newProps.orderFilter.split('-')[1]

      if (orderId !== this.order.order_id || orderWay !== this.order.order_way) {
        this.order.order_id = orderId
        this.order.order_way = orderWay
        this.firstLoad(newProps.request.params);
      }
    }

    /*if (
      this.isInfiniteList() &&
      newProps.request.uri !== '' &&
      newProps.request.uri === this.uri &&
      this.props.request &&
      this.props.request.params &&
      this.props.request.params.node_id == newProps.request.params.node_id && !newProps.request.params.filter_id
    ) {
      return;
    }*/
    if (
      this.isInfiniteList() &&
      newProps.request.uri !== '' &&
      newProps.request.uri === this.uri &&
      ((this.props &&
        this.props.request &&
        this.props.request.params &&
        this.props.request.params.filter_id) &&
        (newProps &&
          newProps.request &&
          newProps.request.params &&
          newProps.request.params.filter_id) &&
        (this.props.request.params.filter_id == newProps.request.params.filter_id && !newProps.request.params.node_id))
    ) {
      return;
    }

    if (
      this.isInfiniteList() &&
      newProps.request.uri !== '' &&
      newProps.request.uri === this.uri &&
      (this.props.request && this.props.request.params && this.props.request.params.filter_id == newProps.request.params.filter_id) &&  (this.props.request.params.node_id == newProps.request.params.node_id)
    ) {
      return;
    }

    this.uri = newProps.request.uri;
    this.firstLoad(newProps.request.params);
  }

  componentDidUpdate(prevProps, prevState) {
    const lastElement = parseInt(this.lastElement);
    if (
      prevState.channels &&
      prevState.channels[1] &&
      prevState.channels[1][0] &&
      prevState.channels[1][0].id &&
      this.state.channels &&
      this.state.channels[0] &&
      this.state.channels[0][0] &&
      this.state.channels[0][0].id
    ) {
      const prevSecondRowFirsElement = prevState.channels[1][0].id;
      const nowFirstRowFirstElement = this.state.channels[0][0].id;

      if(prevSecondRowFirsElement === nowFirstRowFirstElement){
        //logger.debug('>>> movimiento hacia abajo');
        //Verificando que no sea la ultima fila
        if (this.state.channels[2]) {
          //Si la lista infinita no tiene los 4 elementos
          if (this.state.channels[2].length < this.totalChannels) {
            //Toma el ultimo valor del card, hacemos focus en el elemento
            window.SpatialNavigation.focus(
              `.channels-container a[data-counter="${(lastElement+this.totalChannels)}"]`
            );
          } else {
            //Si la lista infinita tiene los 4 elementos
            this.focusHandler(this.state.channels[1][this.getColumn(lastElement+this.totalChannels)]);
          }
        } else {
          //Cuando es la ultima fila
          if((lastElement+this.totalChannels) >= this.totalCategory){
            window.SpatialNavigation.focus(
              `.channels-container a[data-counter="${(this.totalCategory-1)}"]`
            );
          }
        }
        return;
      }
    }

    if (
      prevState.channels &&
      prevState.channels[0] &&
      prevState.channels[0][0] &&
      prevState.channels[0][0].id &&
      this.state.channels &&
      this.state.channels[1] &&
      this.state.channels[1][0] &&
      this.state.channels[1][0].id
    ) {
      const nowSecondRowFirstElement = this.state.channels[1][0].id;
      const prevFirstRowFirsElement = prevState.channels[0][0].id;

      if (nowSecondRowFirstElement === prevFirstRowFirsElement) {
        //logger.debug('>>> movimiento hacia arriba');
        this.focusHandler(this.state.channels[0][this.getColumn(lastElement)]);
        return;
      }
    }

    if (
      this.lastDirection === 'down' &&
      this.state.channels[1] &&
      this.state.channels[1][this.getColumn(lastElement)]
    ) {
      //logger.debug('>>>>> DOWN this.state.channels[1][col]', this.state.channels[1][this.getColumn(lastElement)].title);
      this.focusHandler(this.state.channels[1][this.getColumn(lastElement)]);
    } else if (
      this.lastDirection === 'up' &&
      this.state.channels[0] &&
      this.state.channels[0][0]
    ) {
      //logger.debug('>>>>> UP this.state.channels[0][col]', this.state.channels[0][0].title);
      this.focusHandler(this.state.channels[0][0]);
    }

    window.SpatialNavigation.makeFocusable();
  }

  getColumn(numElement) {
    const numColsXRow = this.props.cols;

    let col = 0;
    let colFactor = (parseInt(numElement, 10) / numColsXRow).toFixed(2).split('.')[1];

    switch (colFactor) {
      case '00':
        col = 0;
        break;
      case '25':
        col = 1;
        break;
      case '50':
        col = 2;
        break;
      case '75':
        col = 3;
        break;
      default:
    }

    return col;
  }

  resetProps() {
    this.currentUpPage = 1;
    this.currentDownPage = -1;

    this.channels = {
      up: [],
      middle: [],
      down: []
    };

    this.setState({ channels: this.channels.middle });
  }

  getDirection(event) {
    return !event.detail || !event.detail.direction
      ? null
      : event.detail.direction.toUpperCase();
  }

  addClassnameFirstElementFocusable(channels){
    const getElement = channels && document.getElementById(`${ID_NAME_FIRST_FOCUS_GRID_SECOND_LEVEL}_${channels[0][0].id}`)
    if(getElement){
      getElement.classList.add(CLASS_NAME_DEFAULT_FOCUSABLE_LIST_INFINITE)
    }
  }

  firstLoad(params = {}) {
    this.resetProps();
    let quantity = (this.lastDown = this.quantity);
    this.lastUp = 0;

    this.request(Object.assign({}, params, { quantity, from: 0 }), data => {
      //logger.debug('OK veamos la famosa data: ', data)
      let channels = (this.channels.middle = this.createGrid(data));
      const isInfinite = this.isInfiniteList();
      if (isInfinite) {
        channels = this.setLastRowNonFocusable(channels);
      }
      this.totalChannels = channels[0] ? channels[0].length : 4;
      this.setState({ channels });
      this.flagFirstLoad = true;

      const isMundial2026 = window.location.pathname.includes(MUNDIAL_2026);

      // Valida si channels tiene elementos para poner el foco y si es un nodo diferente al mundial 2026
      if (Array.isArray(channels) && channels.length > 0 && !isMundial2026) {
        this.addClassnameFirstElementFocusable(channels)
        !this.props.setChargeList && Utils.setInitialFocusChangeTime(`#${ID_NAME_FIRST_FOCUS_GRID_SECOND_LEVEL}_${channels[0][0].id}`, 1000)
      }
    });
  }

  request(params, callback) {

    let requestParams = Object.assign({},this.props.request.params);
    let paramsCb = Object.assign({},params);

    if (this.uri === undefined || this.uri === '') {
      return;
    }

    if(paramsCb['node_id'] && !paramsCb['filter_id']){
      delete requestParams['filter_id'];
    }

    if(paramsCb['filter_id'] && !paramsCb['node_id']){
      delete requestParams['node_id'];
    }

    if (this.order.order_id && this.order.order_way) {
      paramsCb['order_id'] = this.order.order_id
      paramsCb['order_way'] = this.order.order_way
    }

    const newParams = Object.assign({}, requestParams, paramsCb);

    try {
      const task = new ListTask(this.uri, newParams);
      const promise = RequestManager.addRequest(task);

      promise.then(response => {
        if (parseInt(response.status) !== 1) {
          // Se necesita delimitar el máximo de elementos que hay en esa categoría y bloquear las peticiones cuando tienda a ese número.
          this.totalCategory = response.response.total;
          logger.debug(' TOTAL CATEGORY: ', this.totalCategory);
          const groups = Parser.parserList(response, this.uri);
          callback(groups);
        }
      });
    } catch (e) {
      logger.error('error getting List Task', e);
    }
  }

  createGrid(data) {
    let grid = [];
    let flag = false;
    if (data.length > this.itemsByRow) {
      for (let i = 0, row = data.length; i < row; i += this.itemsByRow) {
        let aRow = data.slice(i, i + this.itemsByRow).map(item => item.id);
        if (this.allItems.length !== 0) {
          this.allItems.forEach(item => {
            for (let j = 0; j < aRow.length; j++) {
              if (item === aRow[j]) {
                flag = true;
              }
            }
          });
          if (!flag) {
            this.allItems.push(...aRow);
            flag = false;
          }
        } else this.allItems.push(...aRow);
        grid.push(data.slice(i, i + this.itemsByRow));
      }
    } else if (data.length) {
      grid = [data];
    }
    return grid;
  }

  onFocusDownHandler(event) {
    document.getElementsByClassName('focus-container')[0].style.display = "none";
    this.lastDirection = event.detail.direction;
    if (this.getDirection(event) !== this.DOWN) return;
    let quantity = this.quantity;

    if (this.lastDown - this.itemsByRow < this.totalCategory) {
      let rows = 1;
      if(this.isInfiniteList){
        rows = 2;
      }
      this.request(
        Object.assign({}, { quantity, from: this.lastDown - this.itemsByRow * rows }),
        payload => {
          /*  payload.map((channel, channelIndex) => {
if( this.counter < this.totalCategory ){ // Si el contador es mayor que el número de contenido deja de summarle
  this.counter++;
  channel.positionInfinite = this.counter;
  channel.focusable = true;
}
});*/

          let payloadArray = this.createGrid(payload);
          this.lastUp = this.lastUp + this.itemsByRow; //this.channels.middle[0][0].positionInfinite; // porque a partir de esta posicion vamos a pedir los elementos
          let algo = this.channels.middle.slice(3, 10);
          let concatenado = algo.concat(payloadArray);
          this.lastDown = this.lastDown + this.itemsByRow;
          this.channels.middle = this.setLastRowNonFocusable(concatenado);

          this.setState({ channels: this.channels.middle });

          document.getElementsByClassName('focus-container')[0].style.display = "block";
        }
      );
    }
  }

  onFocusUpHandler(event) {
    this.lastDirection = event.detail.direction;
    if (this.getDirection(event) !== this.UP) return;

    let quantity = this.quantity;
    /* let counter = this.lastUp;*/
    if (this.lastUp > 0){
      event.preventDefault();
      event.stopPropagation();

      let from = this.lastUp - this.itemsByRow;
      if(from > this.totalCategory) {
        const newFrom = Math.trunc(this.totalCategory / this.itemsByRow);
        from = (newFrom) * 4;
      }

      this.request(
        Object.assign({}, { quantity, from }),
        payload => {
          logger.debug('payload response en UP: ', payload); // Aquí tal vez rompa
          /*
payload.map((channel, channelIndex) => {
channel.positionInfinite = counter;
channel.focusable = true;
counter++;
});*/

          let payloadArray = [...this.createGrid(payload)];
          let finalArray = [...this.channels.middle.slice(3, 10)];
          logger.debug('Arreglo concatenado super mil ochomil final ', finalArray);
          payloadArray = [...payloadArray, ...finalArray];
          logger.debug(
            'Arreglo concatenado super mil ochomil final payload',
            payloadArray
          );

          this.channels.middle = this.setLastRowNonFocusable(payloadArray);
          this.lastUp = this.lastUp - this.itemsByRow;
          this.lastDown = this.lastDown - this.itemsByRow;

          this.setState({ channels: this.channels.middle });
        }
      );
    }
  }

  // Metodos para Listado Infinito.
  getType() {
    switch (this.gridType) {
      case this.typeEnum.Infinite:
        return 'infinite';
      default:
        return 'channel';
    }
  }

  isInfiniteList() {
    return this.gridType === this.typeEnum.Infinite;
  }

  setLastRowNonFocusable(channels) {
    for (let i = 0; i < channels.length; i++) {
      const isFocusable = i === 2 ? false : true;
      channels[i].map(e => {
        e.focusable = isFocusable;
        return e;
      });
    }

    return channels;
  }

  setLastRowFocusable(channels) {
    channels.map((row, index, array) => {
      if (index === array.length - 1) {
        row.map(e => {
          e.focusable = true;
          return e;
        });
      }

      return row;
    });

    return channels;
  }

  onFocusMiddleHandler(element) {
    /*let parentBottom = document.querySelector('div.channels-row:first-of-type').getBoundingClientRect().top;
let lastChildTop = document.querySelector('div.channels-row:last-of-type').getBoundingClientRect().bottom;
if (lastChildTop > parentBottom) {*/

    logger.debug('Last Up', this.lastUp);
    logger.debug('element coutn', element.target.getAttribute('data-counter'));
    logger.debug('Last Down', this.lastDown);

    this.lastElement = element.target.getAttribute('data-counter');
    let itemsByRow = this.isInfiniteList() ? parseInt(this.itemsByRow) * (this.rows - 1) : parseInt(this.itemsByRow);
    const middleElements = this.itemsByRow * (this.rows - 1);

    if (
      this.lastElement >= this.lastDown - itemsByRow &&
      this.lastElement <= this.lastDown - 1 &&
      this.getDirection(element) === this.DOWN
    ) {
      this.onFocusDownHandler(element);
    } else if (
      this.lastElement >= this.lastUp &&
      this.lastElement <= this.lastUp + (itemsByRow - 1) &&
      this.getDirection(element) === this.UP
    ) {
      if (this.lastUp < 0 && this.lastElement < 0) {
        if(document.getElementsByClassName('ribbon-categories').length > 0){
          window.SpatialNavigation.focus('.scroller-container .focusable.selected');
        }else{
          window.SpatialNavigation.focus('.nav-container .nav-item.focusable.active');
        }
      }
      else {
        this.onFocusUpHandler(element);
      }
    }
  }

  willUnfocusMiddleHandler(element) {
    if (element) {
      element.addEventListener('sn:willmove', this.onFocusMiddleHandler);
    }
  }

  focusHandler(data) {
    logger.debug('Entramos al handler', data); // Siempre va a entrar aqui
    if (data.id) data.group_id = data.id;
    if (typeof this.props.focusHandler === 'function') {
      this.props.focusHandler(data);
    }
  }

  getPosition(id) {
    for (let i = 0; i < this.allItems.length; i++) {
      if (this.allItems[i] === id) return i;
    }
  }

  counterRecover(contador) {
    this.counter = contador;
    logger.debug('Mandame el contador profa', this.counter);
  }

  dataUpdateMetrics(dataMetricsRibbon){
    const ribbonUtils = new RibbonsUtil()
    ribbonUtils.dataUpdateMetrics(dataMetricsRibbon)
  }

  getNextFocus(direction, channel, channelIndex, row, rowIndex) {

    switch (direction) {
      case 'up':
        return this.getNextFocusUp( channelIndex, rowIndex)
      case 'down':
        return this.getNextFocusDown(channel, channelIndex, rowIndex)
      default:
        return false;
    }

  }

  getNextFocusUp(channelIndex, rowIndex){

    if (this.isFirstRow(rowIndex)) return false;

    const next = this.markupArray[rowIndex-1][channelIndex];

    if (next) return next.id;

    return false;

  }

  getNextFocusDown(channel, channelIndex, rowIndex){

    if (this.isLastRow(rowIndex)) return channel.id;

    const next = this.markupArray[rowIndex+1][channelIndex];

    if (next) return next.id;

    return false
  }

  isFirstRow(rowIndex){
    return rowIndex === 0
  }

  isLastRow(rowIndex){
    return rowIndex === (this.markupArray.length-1)
  }

  handleScroll(event) {
    removeDynamicFocus();
  }

  setRefScroll = (element) => {
    if(this.isMagicControlActive){
        this.divScrolleable = element;
    }
}

  render() {
    this.markupArray = [...this.state.channels];
    logger.debug('markupArray: ', this.markupArray);
    let flag = this.flagFirstLoad;

    return (
      <div
        className="channels-wrapper"
        ref={div => (this.channelsWrapper = div)}
        style={{ width: this.props.width }}
      >
        <div className={this.rootClass}>
          {this.markupArray.map((row, rowIndex) => {
            logger.debug('RowIndex', row);

            return (
              <div key={rowIndex} className={this.isMagicControlActive ? "channels-row-with-scroll" : "channels-row"}
              ref={this.setRefScroll}>
                {row.map((channel, channelIndex) => {
                const idNumber = channel.group_id
                    ? channel.group_id
                    : channel.id
                      ? channel.id
                      : null;

                  let willUnfocusHandler = () => {};

                  if (1) {
                    willUnfocusHandler = this.willUnfocusMiddleHandler;
                  }

                  const badges = getBadges(
                    this.props.user,
                    channel.proveedor_code,
                    channel.format_types,
                    channel.live_enabled
                  );
                  channel.provider = channel.proveedor_code;

                  if(channel.format_types && Array.isArray(channel.format_types)){
                    channel.format_types = channel.format_types;
                  }
                  else if(channel.format_types && channel.format_types.indexOf(',')!==-1){
                    channel.format_types = channel.format_types.split(',');
                  }
                  else if(channel.format_types){
                    channel.format_types = [channel.format_types];
                  }
                  // Evita que los focos vallan hacia la izquierda o hacia la derecha.
                  const focusLeft =
                    channelIndex === 0 ? `#infinitysection_link_${channel.id}` : null;
                  const focusRight =
                    channelIndex === this.props.cols
                      ? `#infinitysection_link_${channel.id}`
                      : null;
                  const dataMetricsRibbon = {
                        node_item: {title : channel.title, provider : channel.provider},
                        node_location : location.pathname,
                        ribbon_title : ""
                    }

                  const focusUp = this.getNextFocus('up', channel, channelIndex, row, rowIndex);
                  const focusDown = this.getNextFocus('down', channel, channelIndex, row, rowIndex);

                  const cardProps = {
                    typeRender: this.gridType === this.typeEnum.Channel ? 'a' : 'Link',
                    ribbonLength: row.length + 1,
                    key: channelIndex,
                    index: channelIndex,
                    ribbonId: "infinitysection",
                    cover: channel.image_small,
                    group_id: channel.group_id || channel.id,
                    title: channel.title,
                    label: channel.label,
                    sibling: channel.sibling,
                    hideInnerTitle: channel.hideInnerTitle ? true : false,
                    type: this.getType(),
                    focusable: channel.focusable,
                    badges: badges,
                    provider: channel.provider || null,
                    live_enabled: channel.live_enabled || null,
                    // Estas propiedades las requiere InfiniteList
                    id: idNumber,
                    positionInfinite: this.lastUp + channelIndex + this.itemsByRow * rowIndex,
                     // Está prop me permite hacer pop() y unshift() de los elemnetos del grid.
                    focusRight,
                    focusLeft,
                    data: channel,
                    onClickCb: e => {
                      if (this.props.onHide) {
                        this.props.onHide();
                      }
                    },
                    focusHandler: this.focusHandler,
                    onLoadHandler: willUnfocusHandler,
                    setMetricsEvent: this.props.setMetricsEvent,
                    dataMetric: {
                      cardPosition: this.getPosition(channel.id)
                    },
                    onClick: (channel.live_enabled && parseInt(channel.live_enabled) === 1)
                      ? (e) => {
                        this.dataUpdateMetrics(dataMetricsRibbon)
                        e.preventDefault();
                        e.stopPropagation();
                        this.props.onClickHandler(channel);
                      }
                      : () => {
                        this.dataUpdateMetrics(dataMetricsRibbon)
                        logger.debug(
                          '==> Este evento es solo para que pase el flujo en CARD'
                        )
                      }
                  };

                  if(this.isInfiniteList()){
                    if(this.isFirstRow(rowIndex) && this.haveMenu){
                      cardProps.focusUp = `#secondlevel_link_1`;
                      if(focusDown) cardProps.focusDown = `#${cardProps.ribbonId}_${cardProps.type}_link_${focusDown}`;
                    }
                    else{
                      if(focusUp) cardProps.focusUp = `#${cardProps.ribbonId}_${cardProps.type}_link_${focusUp}`;
                      if(focusDown) cardProps.focusDown = `#${cardProps.ribbonId}_${cardProps.type}_link_${focusDown}`;
                    }
                  }
                  return (
                    <Card {...cardProps} />
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

/**
 * @type {{request: {uri: *, params: *}, gridType: shim, rows: shim, cols: shim}}
 */
Grid.propTypes = {
  user: PropTypes.object,
  request: PropTypes.object.isRequired,
  gridType: PropTypes.number,
  rows: PropTypes.number,
  cols: PropTypes.number,
  focusHandler: PropTypes.func,
  keyUpHandler: PropTypes.func
};

Grid.defaultProps = {
  user: null,
  gridType: 1,
  rows: 3,
  cols: 5,
  focusHandler: () => {},
  keyUpHandler: () => {}
};

export default Grid;



// WEBPACK FOOTER //
// ./src/components/GridNew/index.jsx